(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-schedule-intro"]) return;
  try {
    
  const buttonViewDetails = document.querySelectorAll('.schedules .card__content .actions.schedules .card__content .actionsbutton.view-details');

  document.addEventListener('DOMContentLoaded', function () {
      
      // Get all buttons with the class 'toggleButton'
      var toggleButtons = document.querySelectorAll('.schedules .card__content .actions button.view-details');
      var cardDescriptions = document.querySelectorAll('.schedules .card__description');

      cardDescriptions.forEach(function(el) {
        var height = el.offsetHeight;
        el.setAttribute('data-height', height);
        el.style.height = '0px';
      })

      // Add click event listener to each button
      toggleButtons.forEach(function(toggleButton) {
        toggleButton.addEventListener('click', function () {
          toggleButton.classList.toggle('open');

          // Find the closest ancestor with the class 'wrapper'
          
          var wrapperElement = toggleButton.closest('.card__content');

          if (wrapperElement) {
            // Get the sibling of the wrapper element
            var siblingElement = wrapperElement.nextElementSibling;
           

            if (siblingElement) {
              // Toggle the class on the sibling element
              var siblingElementHeight = siblingElement.getAttribute('data-height');
              
              if( !siblingElement.classList.contains('open') ){
                siblingElement.style.height = siblingElementHeight+'px';
                
              }else{
                siblingElement.style.height = '0px';
              }
              siblingElement.classList.toggle('open');
              
            } else {
              console.error('No sibling element found.');
            }
          } else {
            console.error('No wrapper element found.');
          }
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
      
    document.addEventListener('DOMContentLoaded', function () {
        // Check if the user has seen the popup
        if (!Cookies.get('popupShown')) {
            // If not, display the popup with dynamic content
            showPopup();

            // Set a cookie to remember that the popup has been shown
           
        }

        var buttonClose = document.getElementById('close-button');
      
        if (buttonClose) {
            buttonClose.addEventListener('click', function(e){
               buttonClose.parentNode.style.display = "none";
               Cookies.set('popupShown', 'true', { expires: 1 }); // 1 day expiration (adjust as needed)
            })
        }
    });

    function showPopup() {
        var popup = document.getElementById('popup-section');
        if (popup) {
            popup.style.display = 'block';
        }
    }

   function isHomepage() {
        // Modify this condition based on your theme's structure
        return (window.location.pathname === '/') || (window.location.pathname === '/fr') ;
    }




  } catch(e) { console.error(e); }
})();
})();
